////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: Toast bridge — the single notistack provider for the whole app  //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import type { ReactNode } from 'react';
import { SnackbarProvider } from 'notistack';

export interface ToastProviderProps {
  children: ReactNode;
}

/** Wraps the app once, in App.tsx. Everything else calls notistack's own
 * `useSnackbar()` directly — this component's only job is to own the single
 * provider instance so it is never accidentally duplicated per-route. */
export function ToastProvider ({ children }: ToastProviderProps) {
  return (
    <SnackbarProvider maxSnack={3} autoHideDuration={5000}>
      {children}
    </SnackbarProvider>
  );
}
